import styled, { css } from 'styled-components';

import { Flexer } from '@ontruck/orc';

const disabledStyles = ({ actionsDiabled }) =>
  actionsDiabled &&
  css`
    opacity: 0.5;
  `;

const StyledRow = styled(Flexer.Parent).attrs(() => ({ alignItems: 'center' }))`
  background: #fff;
  border: 1px solid ${(props) => props.theme.base.colorSchema.greyMouse};
  ${({ clickable }) => clickable && 'cursor: pointer;'}
  & + & {
    border-top: 0;
  }
  max-width: 1400px;
  margin: 0 auto;

  ${disabledStyles}
`;

export default StyledRow;
